import { render } from "./PendingOrders.vue?vue&type=template&id=068b1fac"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/PendingOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "068b1fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('068b1fac', __exports__)) {
    console.log('reload')
    api.reload('068b1fac', __exports__)
  }
  
  module.hot.accept("./PendingOrders.vue?vue&type=template&id=068b1fac", () => {
    console.log('re-render')
    api.rerender('068b1fac', render)
  })

}


export default __exports__